module.exports = __webpack_public_path__ + "img/pop_img_location_fail.45d5d21a.png";